import { initStore } from '../lib/store/main.store';
import type { LayoutLoad } from './$types';

export const load = (async ({ data, url }) => {
	const isModal = url.searchParams.get('popup');
	initStore(url.pathname.includes('LearnMore') ? isModal !== 'false' : !!isModal && isModal !== 'false');
	return data;
}) satisfies LayoutLoad;
